<template>
  <div>
    <!-- Calendario vero e proprio -->
    <div class="wg-row grid-header">
      <div
        v-for="(num, index) in 7"
        :key="'grid-head-'+index"
        class="com-anm22-app-text-l wg-row day-of-week"
      >{{ $moment().isoWeekday(num).format('ddd').toUpperCase() }}</div>
    </div>
    <div class="vertical-height-div" style="height:5px;"></div>
    <div class="grid-container">
      <div v-for="(element, index) in monthMatrix" :key="'day-cell-'+index" class="grid-cell">
        <div
          :class="['wg-row', 'day-block', !element.day.isSame(month, 'month') ? 'other-month' : '']"
          @click="$emit('setDeliveryDate', element.day.utc().format('YYYY-MM-DD'))"
        >
          <div
            class="com-anm22-app-text-m"
            style="align-self:center;"
          >{{ element.day.format('DD') }}</div>
          <!-- Elenco consegne -->
          <div class="day-projects-div com-anm22-app-scrolling-panel">
            <div
              v-for="(row,index) in element.rows.sort((a,b) => a.priority - b.priority)"
              :key="element.day.format('D')+'-project-'+index"
              class="wg-row com-anm22-app-text-s project-label"
              :style="{ color: row.color }"
              :title="row.label"
            >{{ row.label }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- Ricerca disponibilità REV'IT! -->
    <div v-if="projectId" class="revit-scheduling-block">
      <div class="wg-row" style="align-items:center;">
        <div
          v-if="!schedulingLoading"
          class="revit-scheduling-btn"
          @click="searchRevitAvailability"
        >{{ $anm22.strLang(lang, 'Search availability', 'Cerca disponibilità') }}</div>
        <div v-else class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Searching...', 'Ricerca in corso...') }}</div>
      </div>
      <template v-if="schedulingResult">
        <div class="vertical-height-div" style="height:10px;"></div>
        <template v-if="schedulingResult.success">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, 'Proposed date', 'Data proposta') }}:
            <strong>{{ $moment.unix(schedulingResult.proposedDate).utc().format('DD/MM/YYYY') }}</strong>
          </div>
          <template v-if="schedulingResult.shifts.length > 0">
            <div class="com-anm22-app-text-s" style="margin-top:8px;font-weight:600;">{{ $anm22.strLang(lang, 'Projects to be shifted', 'Progetti che verranno spostati') }}</div>
            <div
              v-for="(shift, index) in schedulingResult.shifts"
              :key="'revit-shift-' + index"
              class="wg-row com-anm22-app-text-s revit-shift-row"
            >
              <div class="revit-shift-col">{{ shift.project.projectId }}</div>
              <div class="revit-shift-col">{{ shift.project.name }}</div>
              <div class="revit-shift-col">{{ $moment.unix(shift.oldEndDate).utc().format('DD/MM/YYYY') }}</div>
              <div class="revit-shift-col">&rarr; {{ $moment.unix(shift.newEndDate).utc().format('DD/MM/YYYY') }}</div>
            </div>
          </template>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div
            v-if="schedulingResult.simulate && !schedulingLoading"
            class="revit-scheduling-btn"
            @click="confirmRevitSchedule"
          >{{ $anm22.strLang(lang, 'Confirm and apply', 'Conferma e applica') }}</div>
          <div v-else-if="!schedulingResult.simulate" class="com-anm22-app-text-m revit-scheduling-applied">
            &#10003; {{ $anm22.strLang(lang, 'Schedule applied', 'Programmazione applicata') }}
          </div>
        </template>
        <div v-else class="com-anm22-app-text-s revit-scheduling-error">{{ schedulingReasonLabel }}</div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    month: Object,
    projectId: [Number, String],
    active: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      events: [],
      schedulingLoading: false,
      schedulingResult: null
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang
    }),
    schedulingReasonLabel() {
      if (!this.schedulingResult) {
        return "";
      }
      const reasons = {
        NOT_CATEGORY_1: this.$anm22.strLang(
          this.lang,
          "This project is not a new suit (category 1).",
          "Questo progetto non è una tuta nuova (categoria 1)."
        ),
        NO_SLOT_WITHIN_WINDOW: this.$anm22.strLang(
          this.lang,
          "No available slot within 14 weeks.",
          "Nessuno slot disponibile entro le 14 settimane."
        ),
        CANNOT_FREE_SLOT: this.$anm22.strLang(
          this.lang,
          "Unable to free a slot for the requested date.",
          "Impossibile liberare uno slot per la data richiesta."
        )
      };
      return (
        reasons[this.schedulingResult.reason] ||
        this.$anm22.strLang(
          this.lang,
          "Unable to schedule this project.",
          "Impossibile pianificare questo progetto."
        )
      );
    },
    monthMatrix() {
      let matrix = [];
      // prendo il primo giorno della settimana al cui interno di trova l'inizio del mese
      const firstDay = this.month
        .clone()
        .utc()
        .startOf("month")
        .startOf("isoWeek");
      const lastDay = this.month
        .clone()
        .utc()
        .endOf("month")
        .endOf("isoWeek");
      let selector = firstDay.clone();
      while (selector.isSameOrBefore(lastDay, "day")) {
        //Recupero i progetti con consegna questo giorno
        const rows = this.events
          .filter(d =>
            this.$moment
              .unix(d.endTimestamp)
              .utc()
              .isSame(selector, "day")
          )
          .map(d => {
            return {
              "label": d.name,
              "color": d.color,
              "priority": d.endTimestamp
            };
          });
        //inserisco il giorno nella matrice
        matrix.push({
          day: selector.clone(),
          rows
        });
        //incremento il giorno
        selector.add(1, "days");
      }
      return matrix;
    }
  },
  watch: {
    month() {
      this.loadCalendar();
    }
  },
  methods: {
    getLabelColor(project, docs) {
      if (project.category == 2) {
        return "#ffca28";
      } else if (docs.data.company === "vrs") {
        return "#00af87";
      } else {
        return "red";
      }
    },
    getLabel(project, docs) {
      let string = "";
      // Simboli
      const tasks = this.$store.getters["tasks/getByProject"](
        project.idWorldProject
      );
      tasks.forEach(t => {
        if (t.name === "Finitura" && t.status === 3) {
          string += "*";
        }
        if (t.name === "Carta modello" && t.status === 3) {
          string += "!";
        }
        if (t.name === "Produzione" && t.status === 3) {
          string += "/";
        }
      });
      if (!docs.delivery.confirmed) {
        string += "?";
      }
      if (docs.graphics.printTreatment) {
        string += "$";
      }
      string += " ";
      // Nome cliente
      if (docs.data.firstName) {
        string += docs.data.firstName + " ";
      }
      if (docs.data.lastName) {
        string += docs.data.lastName + " ";
      }
      // Metodo di consegna
      if (docs.delivery.devliveryType) {
        switch (docs.delivery.devliveryType) {
          case "pickUp":
            string += "V ";
            break;
          case "call":
            string += "C ";
            break;
          case "shipping":
            string += "S ";
            break;
          default:
            string += docs.delivery.devliveryType.toUpperCase();
        }
      }
      string += project.name || "";
      string += project.projectId && project.name ? " - " : "";
      string += project.projectId || "";

      return string;
    },
    loadCalendar() {
      //Devo recuperare tutti i vircos-docs dei progetti per popolare il calendario
      this.$http
        .get("vircos/projects-calendar?idWork=16&currentTime=" + this.month.unix())
        .then(response => {
          this.events = response.data.events;
        })
        .catch(error => console.log(error));
    },
    searchRevitAvailability() {
      this.schedulingLoading = true;
      this.schedulingResult = null;
      this.$http
        .post(
          "vircos/revit-schedule-project",
          { projectId: this.projectId, simulate: true },
          { withCredentials: true }
        )
        .then(response => {
          this.schedulingResult = response.data;
        })
        .catch(error => console.log(error))
        .finally(() => {
          this.schedulingLoading = false;
        });
    },
    confirmRevitSchedule() {
      this.schedulingLoading = true;
      this.$http
        .post(
          "vircos/revit-schedule-project",
          { projectId: this.projectId, simulate: false },
          { withCredentials: true }
        )
        .then(response => {
          this.schedulingResult = response.data;
          this.loadCalendar();
        })
        .catch(error => console.log(error))
        .finally(() => {
          this.schedulingLoading = false;
        });
    }
  },
  created() {
    this.loadCalendar();
  }
};
</script>

<style lang="scss" scoped>
.day-of-week {
  width: calc(100% / 7);
  justify-content: center;
}
// Griglia 5x7 per la visualizzazione del mese
.grid-container {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-template-rows: repeat(5, 1fr);
  border-right: 1px solid #bbb;
  border-bottom: 1px solid #bbb;
  background-color: #f9f9f9;
}
// Stile di una cella (grid-item) corrispondente ad un giorno
.grid-cell {
  height: 105px;
  min-width: calc(100% / 7);
  border-left: 1px solid #bbb;
  border-top: 1px solid #bbb;
}
.day-block {
  height: 100%;
  flex-direction: column;
  flex-wrap: nowrap;
  padding: 0 2px;
  cursor: pointer;
  &.other-month {
    opacity: 0.4;
  }
  &:hover {
    background-color: #eee;
  }
}
.day-projects-div {
  height: 100%;
  & div {
    height: calc(100% / 6);
    padding: 1px 2px;
  }
}
.project-label {
  flex-wrap: nowrap;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-radius: 2px;
  background-color: #fff;
}
// Ricerca disponibilità REV'IT!
.revit-scheduling-block {
  padding: 10px 2px;
}
.revit-scheduling-btn {
  cursor: pointer;
  display: inline-block;
  padding: 6px 12px;
  background-color: #eee;
  color: #000;
  border-radius: 6px;
  font-size: 14px;
  &:hover {
    background-color: #ddd;
  }
}
.revit-shift-row {
  flex-wrap: nowrap;
  align-items: center;
  padding: 2px 0;
}
.revit-shift-col {
  width: 25%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-right: 5px;
}
.revit-scheduling-applied {
  color: #00af87;
}
.revit-scheduling-error {
  color: red;
}
</style>
